import { Button, Meta, theme } from 'aimo-ui';
import { format } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSubscriptionStore } from 'stores/subscriptionStore';
import { StyledWrapper } from 'styles/ContainerStyles';
import { useUiStore } from 'stores/uiStore';

const CancelSubscriptionModal: React.FC = () => {
  const { t } = useTranslation();
  const { nextBillingDate, setIsRecurring } = useSubscriptionStore();

  const toggleRenewalOff = () => {
    setIsRecurring(false);
    useUiStore.getState().setSheetModal('');
  };

  const continueRenewal = () => {
    useUiStore.getState().setSheetModal('');
  };

  return (
    <StyledWrapper mb={0}>
      <StyledWrapper center mb={theme.normalising.heightPixel(20)}>
        <Meta center color={theme.colors.gray300}>
          {t('account.aimoSubscription.modalDescription', {
            date: nextBillingDate ? format(nextBillingDate, 'dd.MM.yyyy') : '',
          })}
        </Meta>
      </StyledWrapper>
      <StyledWrapper mb={theme.normalising.heightPixel(10)}>
        <Button
          testID="confirm-cancel-renewal-button"
          text={t('account.aimoSubscription.cancel')}
          size="l"
          buttonType="alert"
          onPress={toggleRenewalOff}
        />
        <Button
          testID="continue-renewal-button"
          text={t('account.aimoSubscription.continue')}
          size="l"
          buttonType="secondary"
          onPress={continueRenewal}
        />
      </StyledWrapper>
    </StyledWrapper>
  );
};

export default CancelSubscriptionModal;
